// eslint-disable-next-line no-unused-vars
import { h, Component } from 'preact';

import {
  assetResolver,
  isActiveLink,
} from '../../utils';

import {
  navigationItemPropType,
} from '../../propTypes';

import {
  Item,
  NavigationItemContainer,
  NavigationItemLink,
  IconImage,
  Title,
} from './styles';

const PrimaryNavigationMenuItemExtra = ({ item }) => {
  const current = navigationItem => ((isActiveLink(navigationItem.link)) ? 'page' : 'false');

  return (
    <NavigationItemContainer>
      <NavigationItemLink
        aria-current={current(item)}
        href={item.link || null}
        active={isActiveLink(item.link)}
      >
        <Item>
          <IconImage src={assetResolver(`${item.icon}.svg`)} alt="Icon" />
          {item.image && <img src={item.image} alt={item.imageAlt} />}
          {!item.image && <Title>{item.title}</Title>}
        </Item>
      </NavigationItemLink>
    </NavigationItemContainer>
  );
};

PrimaryNavigationMenuItemExtra.propTypes = {
  item: navigationItemPropType,
};

PrimaryNavigationMenuItemExtra.defaultProps = {
  item: null,
};

export default PrimaryNavigationMenuItemExtra;
